import { PERMISSIONS } from "../../constants";
import list from "./BillingAlertList";

export default {
  list,
  name: 'alert-billing',
  permissions: [PERMISSIONS.BILLING_ALERT]
}